import { render, staticRenderFns } from "./PetsSection.vue?vue&type=template&id=5e3d646c&"
import script from "./PetsSection.vue?vue&type=script&lang=js&"
export * from "./PetsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports